<template>
  <div :class="gridClass">
    <BaseInput
      v-bind="$props"
      @update:model-value="$emit('update:modelValue', $event)"
      @validation-changed="handleValidationChanged"
      :maxLength="props.maxLength"
    />
  </div>
</template>

<script setup lang="ts">
import { onMounted } from 'vue';
import BaseInput from './BaseInput.vue';
import type { RegisterFormFieldProps } from '@/types/sellerRegister';

const props = defineProps<RegisterFormFieldProps>();

// Gestion de la validation
const handleValidationChanged = (isValid: boolean) => {
  emit('validation-changed', isValid)
}

const emit = defineEmits<{
  'update:modelValue': [value: string | number | boolean | FileList | null | undefined];
  'validation-changed': [isValid: boolean];
}>();

</script>
